import type CSS from 'csstype';
import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import type { BannerVariant } from './types';

const VARIANT_TO_BACKGROUND_MAP: Record<BannerVariant, CSS.Property.Color> = {
  info: colorsPalettes.blue[100],
};

type StyledBannerContainerProps = {
  $variant: BannerVariant;
};

export const StyledBannerContainer = styled.div<StyledBannerContainerProps>`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 10px 16px 16px 16px;
  background-color: ${({ $variant }) => VARIANT_TO_BACKGROUND_MAP[$variant]};
  border-radius: 4px;
  width: 100%;

  user-select: none;
`;

export const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
`;

export const StyledTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StyledTitle = styled.p`
  margin: 0;
  ${setFontVariant('subtitle1', colorsPalettes.carbon[400])};
`;

export const StyledDescription = styled.p`
  margin: 0;
  ${setFontVariant('body2', colorsPalettes.carbon[400])};
`;
